/**
 * @Author: zhangxiaojian
 * @Date: 2025/5/26
 * @LastEditors: zhangxiaojian
 * @Description 资产稿库API
 **/

import { createAPI } from '../../common'

export default {
  postRootArticlesMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0npwf', 'POST', config), // 稿件移动
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0usbotgfs', 'POST', config), // 送审
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0sfkfdu', 'POST', config), // 驳回
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0qbtt', 'POST', config), // 审核通过
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0efmfuf', 'POST', config), // 稿件删除
  postArticlePrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0qsjou', 'POST', config), // 稿件打印
  getRootFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config), // 获取栏目根节点
  getSubsArticlesTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60gpmefst', 'get', config), // 获取子节点
  getRootArticlesTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60gpmefst', 'get', config), // 获取子节点
  // 资产稿库-详情页操作权限
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60bdujpot0efubjmbdujpot', 'get', config),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  getArticleRootColumn: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0sppu', 'get', config), // 获取资产稿库根栏目
  // 资源稿库-判断是否有回收站权限
  getRecycleRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0hfuSfdzdmf', 'get', config),

  // 资源稿库-还原已删除稿件
  postArticleRevert: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0bsujdmfSfwfsu',
      'post',
      config,
      vconfig
    ),
  // 资源稿库-彻底删除已删除稿件
  postArticleDeleteReal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0efmfufSfbm', 'post', config, vconfig),
  // 资源稿库-签发-app网站
  postArticleIssue: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0jttvf', 'post', config, {
      timeout: 90000,
      ...vconfig
    }),
  // 资源稿库-签发-稿源库
  postArticleSubmit: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0tvcnju', 'post', config, {
      timeout: 90000,
      ...vconfig
    }),
  // 资源稿库-签发-报纸
  postPaperArticlesForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0jttvfQbqfs', 'post', config, {
      timeout: 90000,
      ...vconfig
    }),
  // 资源稿库-签发-期刊
  postJournalArticlesForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0jttvfKpvsobm', 'post', config, {
      timeout: 90000,
      ...vconfig
    }),
  // 其他稿库选用对应资源保存选用
  postEventSaveSelect: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0fwfou0tbwfTfmfdu', 'post', config, vconfig),
  // 资产稿库签发-畅享全媒体3.0稿源库
  signRemoteRootForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0jttvfOfxtfejuSppu', 'post', config, vconfig),
  // 资产稿库签发-畅享全媒体3.0部门库
  signRemoteEditForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bttfu0bttfuBsujdmf0jttvfOfxtfejuFeju', 'post', config, vconfig),
}
